module.exports = __webpack_public_path__ + "img/20260102_Nature.c7b549ca.webp";